const PerformanceTable = () => {
    const performanceData = [
      {
        id: 1,
        rank: 1,
        rmName: 'RM-1',
        branch: '6098 Marjolaine Landing',
        customers: 423,
        amount: '$34,295',
      },
      {
        id: 2,
        rank: 2,
        rmName: 'RM-2',
        branch: '6098 Marjolaine Landing',
        customers: 423,
        amount: '$34,295',
      },
      {
        id: 3,
        rank: 3,
        rmName: 'RM-3',
        branch: '6098 Marjolaine Landing',
        customers: 423,
        amount: '$34,295',
      },
    ];
  
    return (
      <div className="overflow-x-auto">
        <table className="min-w-full">
          <thead>
            <tr className="text-left text-[#B4E50D]">
              <th className="pb-4">Current Rank</th>
              <th className="pb-4">RM Name</th>
              <th className="pb-4">Branch</th>
              <th className="pb-4">Customers</th>
              <th className="pb-4">Amount</th>
            </tr>
          </thead>
          <tbody>
            {performanceData.map((item) => (
              <tr key={item.id} className="border-t border-[#3A3A3A]">
                <td className="py-4 text-[#FFFFFF]">{item.rank}</td>
                <td className="py-4">
                  <div className="flex items-center">
                    <img
                      src={`https://ui-avatars.com/api/?name=${item.rmName}&background=random`}
                      alt={item.rmName}
                      className="w-8 h-8 rounded-full mr-2"
                    />
                    <span className="text-[#FFFFFF]">{item.rmName}</span>
                  </div>
                </td>
                <td className="py-4 text-[#B0B0B0]">{item.branch}</td>
                <td className="py-4 text-[#FFFFFF]">{item.customers}</td>
                <td className="py-4 text-[#B4E50D] font-semibold">{item.amount}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };
  
  export default PerformanceTable;